"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _index = _interopRequireDefault(require("keycode/index"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiUploadInput = _interopRequireDefault(require("./HiUploadInput"));
var _HiIcon = _interopRequireDefault(require("../HiIcon"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    flexContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    statusIcon: {
      height: '80px',
      width: '80px',
      marginRight: '8px',
      padding: '24px',
      borderRadius: '2px',
      backgroundColor: theme.palette.background2,
      border: "1px solid ".concat(theme.palette.warning.main),
      color: "".concat(theme.palette.warning.main, " !important"),
      fontSize: '80px'
    },
    dragOver: {},
    inputContainer: {
      flex: '1',
      width: 'calc(100% - 88px)'
    },
    empty: {
      border: "1px solid ".concat(theme.palette.input.bottomLine),
      color: "".concat(theme.palette.neutral.main, " !important")
    },
    complete: {
      border: "1px solid ".concat(theme.palette.success.main),
      color: "".concat(theme.palette.success.main, " !important"),
      fontSize: '32px'
    },
    error: {
      border: "1px solid ".concat(theme.palette.error.main),
      color: "".concat(theme.palette.error.main, " !important")
    },
    fileButton: {
      marginRight: 8,
      '&$focusable': {
        cursor: 'pointer',
        '&:hover, &:focus, &$dragOver': {
          border: "1px solid ".concat(theme.palette.primary.main),
          color: "".concat(theme.palette.primary.main, " !important")
        }
      }
    },
    focusable: {}
  };
};
var HiUpload = /*#__PURE__*/function (_React$PureComponent) {
  function HiUpload() {
    var _this;
    (0, _classCallCheck2.default)(this, HiUpload);
    _this = _callSuper(this, HiUpload);
    // Action when files are dropped on the field
    _this.handleDrop = function (event) {
      if (event.path[0].id === _this.uploadIconRef.props.id) {
        event.preventDefault();
        event.stopPropagation();
        if (_this.state.droppable) {
          var index = _this.getNextInputIndex();
          var param = _this.handleFile(event.dataTransfer.files, index);
          _this.setState({
            dragOver: false
          });
          _this.props.onChange(param, 0);
        } else {
          _this.setState({
            dragOver: false
          });
        }
      }
    };
    // Action when files are dragged over the field.
    _this.handleDragEnter = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.path[0].id === _this.uploadIconRef.props.id) {
        if (event.dataTransfer.items.length !== 1) {
          event.dataTransfer.dropEffect = 'none';
          _this.props.onChange({
            errorMessage: _this.props.translations.errorDragEnter,
            value: null
          }, 0);
          _this.setState({
            dragOver: true
          });
        } else {
          _this.setState({
            droppable: true,
            dragOver: true
          });
        }
      }
    };
    // Action when files are not dragged over the field anymore.
    _this.handleDragLeave = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.path[0].id === _this.uploadIconRef.props.id && event.relatedTarget.parentElement !== _this.uploadFieldRef) {
        _this.props.onChange({
          errorMessage: '',
          value: null
        }, 0);
        _this.setState({
          droppable: false,
          dragOver: false
        });
      }
    };
    _this.handleChange = function (event) {
      var index = _this.getNextInputIndex();
      var param = _this.handleFile(event.target.files, index);
      _this.props.onChange(param, index);
    };
    _this.handleEmptyField = function (event) {
      event.target.value = '';
    };
    _this.handleKeyPress = function (event) {
      var key = (0, _index.default)(event);
      if (key === 'enter' || key === 'space') {
        event.preventDefault();
        _this.uploadInput.click();
      }
    };
    // Handles the file wether it is selected via the input or dropped on it.
    _this.handleFile = function (files, index) {
      var error = false;
      var errorMessage = '';
      var file = null;
      if (files.length === 1) {
        file = files[0];
        if (_this.props.inputs[index] && file.size > _this.props.inputs[index].maxSize) {
          errorMessage += _this.props.translations.errorSize.replace('maxSize', _this.props.inputs[index].maxSize / 1000000);
          error = true;
        }
        if (_this.props.inputs[index] && _this.props.inputs[index].acceptedTypes && _this.props.inputs[index].acceptedTypes.length !== 0 && _this.props.inputs[index].acceptedTypes.indexOf(file.type) === -1) {
          errorMessage += _this.props.translations.errorType;
          error = true;
        }
      } else {
        errorMessage = _this.props.translations.errorDropMultiple;
      }
      return {
        errorMessage: errorMessage,
        error: error,
        value: file
      };
    };
    _this.createInputs = function (others) {
      var _this$props = _this.props,
        inputs = _this$props.inputs,
        values = _this$props.values;
      var files = inputs;

      // unlimited number of files
      if (inputs.length === 0) {
        files = values;
      }
      var inputComponents = [];
      for (var i = 0; i < files.length; i += 1) {
        if (files.length > 1 || values[i] && values[i].value) {
          inputComponents.push( /*#__PURE__*/_react.default.createElement(_HiUploadInput.default, (0, _extends2.default)({
            maxSize: inputs[i] ? inputs[i].maxSize : undefined,
            acceptedTypes: inputs[i] ? inputs[i].acceptedTypes : undefined,
            placeholder: inputs[i] ? inputs[i].placeholder : undefined,
            value: values[i] ? values[i].value : null,
            error: values[i] ? values[i].error : null,
            errorMessage: values[i] ? values[i].errorMessage : null,
            onSeeFile: _this.handleSeeFile,
            onDeleteFile: _this.props.onDeleteFile,
            onChange: _this.props.onChange,
            index: i,
            key: inputs[i] ? inputs[i].id : "doc-".concat(i)
          }, others)));
        }
      }
      return inputComponents;
    };
    _this.uploadFieldRef = void 0;
    _this.state = {
      dragOver: false,
      droppable: false
    };
    return _this;
  }

  // When component mounts, we add eventListeners to handle the file drag and drop
  (0, _inherits2.default)(HiUpload, _React$PureComponent);
  return (0, _createClass2.default)(HiUpload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.uploadFieldRef.addEventListener('dragenter', this.handleDragEnter, false);
      this.uploadFieldRef.addEventListener('dragleave', this.handleDragLeave, false);
      this.uploadFieldRef.addEventListener('dragover', function (event) {
        event.preventDefault();
      }, false);
      this.uploadFieldRef.addEventListener('drop', this.handleDrop, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uploadFieldRef.removeEventListener('dragenter', this.handleDragEnter, false);
      this.uploadFieldRef.removeEventListener('dragleave', this.handleDragLeave, false);
      this.uploadFieldRef.removeEventListener('dragover', function (event) {
        event.preventDefault();
      }, false);
      this.uploadFieldRef.removeEventListener('drop', this.handleDrop, false);
    }
  }, {
    key: "getNextInputIndex",
    value: function getNextInputIndex() {
      var index = 0;

      // Add an input at the end
      if (!this.props.inputs.length) {
        index = this.props.values.length + 1;
      } else {
        // First empty input
        for (var i = 0; i < this.props.values.length; i += 1) {
          if (!this.props.values[i] || this.props.values[i].error || !this.props.values[i].value) {
            index = i;
            break;
          }
        }
      }
      return index;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        inputs = _this$props2.inputs,
        classes = _this$props2.classes,
        values = _this$props2.values,
        focused = _this$props2.focused,
        others = (0, _objectWithoutProperties2.default)(_this$props2, ["id", "inputs", "classes", "values", "focused"]);
      var _this$state = this.state,
        dragOver = _this$state.dragOver,
        droppable = _this$state.droppable;
      var complete = true;
      var empty = true;
      var error = false;

      // For unlimited inputs: always grey
      if (!inputs.length) {
        complete = false;
      } else if (values.length === 0 || inputs.length > 0 && inputs.length !== values.length) {
        complete = false;
      } else {
        for (var i = 0, len = values.length; i < len; i += 1) {
          var value = values[i];
          if (value !== undefined) {
            complete = value.value === null || value.error ? false : complete;
            empty = value.value !== null && !value.error ? false : empty;
            error = value.error || error;
          } else {
            complete = false;
          }
        }
      }
      var statusClass = (0, _classnames.default)(classes.statusIcon, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.empty, empty), classes.complete, complete));
      var icon;
      if (error) {
        icon = 'warning';
      } else if (complete) {
        icon = 'check_circle';
      } else {
        icon = 'file_upload';
      }
      var focusable = true;
      if (complete && values.length > 1) {
        focusable = false;
      }
      var iconClass = (0, _classnames.default)(statusClass, classes.fileButton, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.dragOver, dragOver), classes.droppable, droppable), classes.focused, focused), classes.error, error && !focused), classes.focusable, focusable));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.flexContainer
      }, /*#__PURE__*/_react.default.createElement("label", {
        ref: function ref(label) {
          _this2.uploadFieldRef = label;
        },
        tabIndex: "-1"
      }, /*#__PURE__*/_react.default.createElement("input", {
        hidden: true,
        type: !complete || values.length === 1 ? 'file' : 'hidden',
        onChange: this.handleChange,
        onClick: focusable ? this.handleEmptyField : undefined,
        ref: function ref(el) {
          _this2.uploadInput = el;
        }
      }), /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
        ref: function ref(uploadIcon) {
          _this2.uploadIconRef = uploadIcon;
        },
        id: "iconUpload-".concat(id),
        className: iconClass,
        icon: icon,
        size: 32,
        tabIndex: focusable ? '0' : '-1',
        onKeyPress: this.handleKeyPress
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.inputContainer
      }, this.createInputs(others)));
    }
  }]);
}(_react.default.PureComponent);
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiUpload'
})(HiUpload);